import React from 'react';
import MultiFilterDropdown from './MultiFilterDropdown';
import {
  CurrentFileTree,
  IUseFolderOptionsProps,
  useCurrentFileTree,
} from './ComplementaryComponents/FileTree/CurrentFileTree';
import { FileOption } from './ComplementaryComponents/FileTree/FileOption';
import { FolderGroup } from './ComplementaryComponents/FileTree/FolderGroup';
import { ItemList } from 'v2/models';
import { CurrentItemListForm } from 'v2/context/CurrentItemListForm';

interface IConnectedFileTreeProps {
  disabled?: boolean;
}

const ConnectedFileTree = ({ disabled }: IConnectedFileTreeProps) => {
  const { loadOptions, defaultOptions } = useCurrentFileTree();
  return (
    <MultiFilterDropdown
      id="allFiles"
      disabled={disabled}
      placeHolder="All Files"
      loadOptions={loadOptions}
      defaultOptions={defaultOptions}
      secondaryPlaceHolder="Select Files"
      noOptionsMessage="No Files"
      components={{
        Option: FileOption,
        // @ts-expect-error because these templated components are hard
        Group: FolderGroup,
      }}
    />
  );
};

interface MultiSelectFilesProps
  extends IUseFolderOptionsProps,
    IConnectedFileTreeProps {
  onChange: (il: ItemList) => void;
}

const MultiSelectFiles = ({
  disabled,
  defaultValues,
  onChange,
  ...rest
}: MultiSelectFilesProps) => {
  return (
    <CurrentItemListForm onChange={onChange} fieldName="fileList">
      <CurrentFileTree defaultValues={defaultValues} {...rest}>
        <ConnectedFileTree disabled={disabled} />
      </CurrentFileTree>
    </CurrentItemListForm>
  );
};

export default MultiSelectFiles;
